<template>
    <div>
        <div class="form-group d-flex align-items-center">
            <h1 class="col-xs-11">
                Categories
                <router-link
                    :to="{name: 'create-category'}"
                    tag="button"
                    type="button"
                    class="btn btn-sm btn-primary mr-1"
                >Create</router-link>
            </h1>
            <form class="form-inline d-flex ml-auto col-xs-11">
                <input
                    autofocus
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="Search By Name"
                    v-model="category_name"
                />
                <button class="btn btn-primary btn-sm ml-1" type="button" @click="Clear()">Clear</button>
            </form>
        </div>

        <div class="alert alert-danger" v-if="error">
            <p class="mb-0">{{ error }}</p>
        </div>

        <datatable
            class="mt-4"
            style="height: 70vh;"
            :cols="columns"
            :rows="array.filter(c => category_name ? c.name.toLowerCase().includes(category_name.toLowerCase()) : true)"
        />
    </div>
</template>

<script>
import store from "../../../store";
import { mapState } from "vuex";
import DataTable from "../../DataTable";
import { createDatatableButtons, getError } from "../../../helpers";
import categories from "../../../store/modules/categories";

export default {
    components: {
        datatable: DataTable
    },

    data() {
        return {
            category_name: null,
            name: null,
            error: null, 
            selectedCategories: [],

            columns: [
                {
                    headerName: "ID",
                    field: "id",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    minWidth: 50,
                    maxWidth: 75
                },
                {
                    headerName: "Name",
                    field: "name",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    minWidth: 150
                },
                {
                    headerName: "Number of products",
                    field: "CountOfProduct",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    minWidth: 150
                },

                {
                    headerName: "Actions",
                    field: "id",
                    minWidth: 250,
                    maxWidth: 250,

                    cellRenderer: params => {
                        const isDeleted = !!params.data.deleted_at;
                        const buttons = [
                            {
                                name: "Edit",
                                type: "secondary",
                                disabled: isDeleted,
                                handler: () => {
                                    this.$router.push({
                                        name: "edit-category",
                                        params: { id: params.value }
                                    });
                                }
                            }
                        ];

                        buttons.push({
                            //name: isDeleted ? 'Restore' : 'Delete',
                            disabled: isDeleted,
                            name: "Delete",
                            type: "danger",
                            handler: () => {
                                if (
                                    confirm(
                                        `Are you sure you want to delete this category ? \nBe careful, all its items will be deleted !`
                                    )
                                ) {
                                    this.error = null;

                                    this.$store
                                        .dispatch("categories/delete", {
                                            id: params.value
                                        })
                                        .catch(e => {
                                            this.error = getError(e);
                                        });
                                }
                            }
                        });

                        return createDatatableButtons(buttons);
                    }
                }
            ]
        };
    },

    computed: {
        ...mapState({
            categories: state =>
                state.categories.categories.map(a => ({ ...a })),
            products: state =>
                state.products.products
                    .filter(c => c.deleted_at == null)
                    .map(a => a.category_id)
		}),
		
        array() {
            return this.categories
                .filter(c =>
                    this.selectedCategories.length == 0
                        ? c.parent_id == null
                        : c.parent_id == this.top.id
                )
                .map(obj => ({
                    ...obj,
                    CountOfProduct: this.products.filter(c => c == obj.id)
                        .length
                }));
		},
		
        top() {
            return this.selectedCategories[this.selectedCategories.length - 1];
        }
	},
	
    methods: {
        Clear() {
            this.category_name = null;
        }
	},
	
    async beforeRouteEnter(to, from, next) {
        await store.dispatch("categories/fetchAll");
        await store.dispatch("products/fetchAll");
        next();
    },

    meta: {
        title: "Categories",

        meta: [{ property: "og:title", content: "Categories / Al-Shayah" }]
    }
};
</script>

<style scoped>
</style>
